module.exports = __webpack_public_path__ + "img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.5ff836e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img_link/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg
// module id = Xo9U
// module chunks = 1